import { render, staticRenderFns } from "./Investimentos.vue?vue&type=template&id=525c9d74&"
import script from "./Investimentos.vue?vue&type=script&lang=js&"
export * from "./Investimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports